import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Analytics initialization if needed
  }, []);

  // Route Change Tracking (Optional for Single Page Apps)
  useEffect(() => {
    if (window.clarity) {
      // Future: Could verify page views here
    }
  }, [location]);

  return null; // This component renders nothing
};

export default Analytics;
